import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "~/lib/utils"

const iconVariants = cva("h-icon", {
  variants: {
    variant: {
      solid: "fas",
      brand: "fab",
      light: "fal",
      custom: "fak",
    },
    size: {
      xs: "h-icon--xs",
      sm: "h-icon--sm",
      md: "h-icon--md",
      xl: "h-icon--xl",
    },
    opticalCorrection: {
      true: "h-icon--optical-correction",
    },
  },
  defaultVariants: {
    variant: null,
    size: null,
    opticalCorrection: false,
  },
})

interface IconProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof iconVariants> {
  icon?: string
}

function Icon({
  className,
  variant,
  size,
  opticalCorrection,
  icon,
  ...props
}: IconProps) {
  return (
    <span
      className={cn(
        iconVariants({ variant, size, opticalCorrection }),
        variant ? "" : "far",
        icon && `fa-${icon}`,
        className,
      )}
      {...props}
    />
  )
}

export { Icon }
